<template>
  <div class="content">
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <md-card>
          <md-card-header data-background-color="green">
            <h4 class="title">
              Service Providers
              <!-- <span
                v-b-modal.new-interpreter
                style="cursor: pointer; font-size: 15px"
                class="fa fa-plus pull-right"
                >Add Service Provider</span
              > -->
            </h4>
            <p class="category">
              View verified service providers registered to your applications
            </p>
          </md-card-header>
          <md-card-content>
            <md-table v-model="searched" md-card md-fixed-header>
              <md-table-toolbar>
                <div class="md-toolbar-section-start">
                  <h1 class="md-title">Service Providers</h1>
                </div>

                <md-field md-clearable class="md-toolbar-section-end">
                  <md-input
                    placeholder="Search by name..."
                    v-model="search"
                    @input="searchOnTable"
                  />
                </md-field>
              </md-table-toolbar>

              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Name" md-sort-by="first_name"
                  >{{ item.first_name }} {{ item.last_name }}
                </md-table-cell>
                <md-table-cell md-label="Contact" md-sort-by="experience">{{
                  item.contact
                }}</md-table-cell>
                <md-table-cell md-label="Email" md-sort-by="experience">{{
                  item.email
                }}</md-table-cell>
                <md-table-cell md-label="Action" md-sort-by="action">
                  <md-button
                    class="md-dense md-raised md-primary btn-sm"
                    @click="setUser(item)"
                    >View</md-button
                  >
                  <!-- <md-button class="md-dense md-raised md-danger btn-sm" v-if="item.status!='blocked'" @click="lc_DelUser(item.id)">Remove</md-button> -->

                  <md-button
                    v-if="item.status == 'active'"
                    class="md-dense md-raised md-warning btn-sm"
                    @click="lc_blockUser(item)"
                    >Block</md-button
                  >
                  <md-button
                    v-else
                    class="md-dense md-raised md-success btn-sm"
                    @click="lc_blockUser(item)"
                    >Unblock</md-button
                  >
                </md-table-cell>
              </md-table-row>
            </md-table>
            <b-modal id="modal-1" size="lg" hide-footer>
              <template v-slot:modal-header>
                <h5 class="ml-auto mr-auto"><b>Details</b></h5>
              </template>
              <b-container>
                <b-tabs content-class="mt-3" class="col-md-12">
                  <b-tab title="Account Information" active>
                    <div class="row">
                      <div class="col-md-6">
                        <div
                          class="p-3 card shadow"
                          style="border: 1px solid #dcdcdc; border-radius: 1rem"
                        >
                          <h4><b>Personal Info</b></h4>

                          <div>
                            <img
                              class="rounded-circle"
                              :src="selected_user.profile_image"
                              style="height: 80px; width: 80px"
                              alt=""
                            />
                          </div>
                          <div class="d-md-flex mt-1">
                            <h6>Name</h6>
                            <p class="ml-2" v-if="edit == false">
                              {{ selected_user.first_name }}
                              {{ selected_user.last_name }}
                              {{ selected_user.middle_name }}
                            </p>
                          </div>
                          <div class="d-md-flex mt-1">
                            <h6>Gender</h6>
                            <p class="ml-2" v-if="edit == false">
                              {{ selected_user.gender }}
                            </p>
                          </div>
                          <div class="d-md-flex mt-1">
                            <h6>Email</h6>
                            <p class="ml-2" v-if="edit == false">
                              {{ selected_user.email }}
                            </p>
                          </div>
                          <div class="d-md-flex mt-1">
                            <h6>Phone Number</h6>
                            <p class="ml-2" v-if="edit == false">
                              {{ selected_user.contact }}
                            </p>
                          </div>

                          <div>
                            <div class="d-md-flex mt-1">
                              <h6><b>Languages</b></h6>
                              <p
                                v-for="(item, i) in selected_user.languages"
                                :key="i"
                              >
                                <b-badge class="ml-1 mt-1" variant="primary">{{
                                  item
                                }}</b-badge>
                              </p>
                            </div>
                          </div>
                          <div>
                            <div class="d-md-flex mt-1">
                              <h6><b>Licensed States</b></h6>
                              <p
                                v-for="(item, i) in selected_user.location"
                                :key="i"
                              >
                                <b-badge class="ml-1 mt-1" variant="primary">{{
                                  item
                                }}</b-badge>
                              </p>
                            </div>
                          </div>
                          <div
                            v-if="
                              selected_user.insurance_file != '' &&
                              selected_user.insurance_file != null
                            "
                          >
                            <div class="d-md-flex mt-1">
                              <h6><b>Insurance</b></h6>
                              <a
                                class="ml-2 mt-1"
                                target="_blank"
                                :href="selected_user.insurance_file"
                              >
                                View Insurance</a
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div
                          class="p-3 card shadow"
                          style="border: 1px solid #dcdcdc; border-radius: 1rem"
                        >
                          <!-- <h4><b>Certifications/Education</b></h4>   -->

                          <!-- <div class="d-md-flex mt-1">
                                                        <h6>NPI Number</h6>
                                                        <p class="ml-2" v-if="edit==false">{{selected_user.npi_number}}</p>

                                                    </div> -->
                          <div class="d-md-flex mt-1">
                            <h6>Degree/Certification</h6>
                            <p class="ml-2" v-if="edit == false">
                              {{ selected_user.certifications }}
                            </p>
                          </div>

                          <div class="d-md-flex mt-1">
                            <h6><b>Specialty</b></h6>
                            <p class="ml-2" v-if="edit == false">
                              {{ selected_user.specialty }}
                            </p>
                          </div>
                          <div
                            v-if="selected_user.certified != 'No'"
                            class="d-md-flex mt-1"
                          >
                            <h6><b>Board Certified</b></h6>
                            <p class="ml-2" v-if="edit == false">
                              {{ selected_user.certified }}
                            </p>
                          </div>

                          <div
                            v-if="selected_user.institute != null"
                            class="d-md-flex mt-1"
                          >
                            <h6><b>Educational Institution</b></h6>
                            <p class="ml-2" v-if="edit == false">
                              {{ selected_user.institute }}
                            </p>
                          </div>
                          <!-- <div class="d-md-flex mt-1">
                                                        <h6> <b>Liability Insurance</b>  </h6>
                                                        <p class="ml-2" v-if="edit==false">{{selected_user.insurance}}</p>
                                                    </div> -->
                        </div>

                        <div
                          v-if="selected_user.about != null"
                          class="mt-2 p-3 card shadow"
                          style="border: 1px solid #dcdcdc; border-radius: 1rem"
                        >
                          <!-- <h4><b>Business Details</b></h4>   -->
                          <!-- <div class="d-md-flex mt-1">
                                                        <h6> <b>Business Name</b>  </h6>
                                                        <p class="ml-2" v-if="edit==false">{{selected_user.business_name}}</p>
                                                    </div>
                                                    <div class="d-md-flex mt-1">
                                                        <h6> <b>Opening</b>  </h6>
                                                        <p class="ml-2" v-if="edit==false">{{selected_user.open_time}}</p>
                                                    </div>
                                                    <div class="d-md-flex mt-1">
                                                        <h6> <b>Closing</b>  </h6>
                                                        <p class="ml-2" v-if="edit==false">{{selected_user.close_time}}</p>
                                                    </div>
                                                    <div class="d-md-flex mt-1">
                                                        <h6> <b>Business Address</b>  </h6>
                                                        <p class="ml-2" v-if="edit==false">{{selected_user.address}}</p>
                                                    </div> -->
                          <div class="d-md-flex mt-1">
                            <h6><b>About You</b></h6>
                            <p class="ml-2" v-if="edit == false">
                              {{ selected_user.about }}
                            </p>
                          </div>
                           <div v-if="selected_user.verification_img!=null" class="d-md-flex mt-1">
                            <h6><b>Verification Image</b></h6>
                            <p class="ml-2" v-if="edit == false">
                              <a :href="selected_user.verification_img" target="_blank" rel="noopener noreferrer">View</a>
                            </p>
                          </div>
                          <div v-if="selected_user.license_img!=null" class="d-md-flex mt-1">
                            <h6><b>License Image</b></h6>
                            <p class="ml-2" v-if="edit == false">
                              <a :href="selected_user.license_img" target="_blank" rel="noopener noreferrer">View</a>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-tab>
                  <b-tab title="Chats" class="col-md-4">
                    <div
                      v-for="(item, i) in getMessagedUsers"
                      :key="i"
                      class="d-md-flex d-flex shadow pr-1 pl-1 pt-1 pb-1"
                      style="border-radius: 1rem"
                    >
                      <img
                        style="width: 50px; height: 50px"
                        class="rounded-circle"
                        :src="
                          item.profile_image != null
                            ? item.profile_image
                            : 'img/avatar.png'
                        "
                        alt=""
                      />
                      <span class="ml-2" style="align-self: center"
                        >{{ item.first_name }} {{ item.last_name }}
                      </span>
                    </div>
                    <!-- <div class="mt-2 d-md-flex d-flex shadow pr-1 pl-1 pt-1 pb-1" style="border-radius:1rem;">
                                            <img width="50" src="img/avatar.png" alt="">
                                            <span class="ml-2" style="align-self:center">Joe Rogan</span>
                                        </div> -->
                  </b-tab>
                </b-tabs>
              </b-container>
              <b-container fluid class="mt-4">
                <md-button
                  class="md-dense md-raised md-primary pull-right"
                  @click="hide('modal-1')"
                  >Cancel</md-button
                >
              </b-container>
            </b-modal>
          </md-card-content>
        </md-card>
      </div>
    </div>
    <b-modal id="new-interpreter" hide-footer>
      <template v-slot:modal-header>
        <h5 class="ml-auto mr-auto"><b>Create New Service Provider </b></h5>
      </template>
      <b-container fluid>
        <div class="row">
          <div class="col-md-12 col-12">
            <label class="d-block text-primary" for="">Profile Pic*</label>
            <input type="file" @change="onFilePicked" />
          </div>
          <div class="col-md-6 col-12 mt-2">
            <label for="" class="text-primary">First Name*</label>
            <input
              type="text"
              name=""
              v-model="interpreterUser.first_name"
              placeholder="John"
              class="form-control"
              id=""
            />
          </div>
          <div class="col-md-6 col-12 mt-2">
            <label for="" class="text-primary">Last Name*</label>
            <input
              type="text"
              name=""
              v-model="interpreterUser.last_name"
              placeholder="Doe"
              class="form-control"
              id=""
            />
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-6 col-12">
            <label for="" class="text-primary">Middle Name</label>
            <input
              type="text"
              name=""
              placeholder="ron"
              v-model="interpreterUser.middle_name"
              class="form-control"
              id=""
            />
          </div>
          <div class="col-md-6 col-12">
            <label for="" class="text-primary">Gender*</label>
            <select
              name=""
              id=""
              class="form-control"
              v-model="interpreterUser.gender"
            >
              <option value="Male">Male</option>
              <option value="Female">Female</option>
            </select>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-5 col-12">
            <label for="" class="text-primary">NPI Number</label>
            <input
              type="text"
              name=""
              placeholder="EBS74"
              v-model="interpreterUser.npi_number"
              class="form-control"
              id=""
            />
          </div>
          <div class="col-md-7 col-12">
            <label for="" class="text-primary"
              >License/Certificate Number</label
            >
            <input
              type="text"
              name=""
              placeholder="CDE374"
              v-model="interpreterUser.certificate_no"
              class="form-control"
              id=""
            />
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-6 col-12">
            <label for="" class="text-primary">Email*</label>
            <input
              type="text"
              name=""
              placeholder="john@gmail.com"
              v-model="interpreterUser.email"
              class="form-control"
              id=""
            />
          </div>
          <div class="col-md-6 col-12">
            <label for="" class="text-primary">Phone*</label>
            <input
              type="number"
              min="0"
              name=""
              placeholder="+123456789"
              v-model="interpreterUser.contact"
              class="form-control"
              id=""
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 col-12 mt-3">
            <label for="" class="text-primary">Password*</label>
            <input
              type="password"
              placeholder="Your Password"
              v-model="interpreterUser.password"
              class="form-control"
              id=""
            />
          </div>
          <div class="col-md-6 col-12 mt-3">
            <label for="" class="text-primary">Confirm Password*</label>
            <input
              type="password"
              name=""
              placeholder="Confirm Password"
              v-model="interpreterUser.confirm_password"
              class="form-control"
              id=""
            />
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-md-6 col-12">
            <label for="" class="text-primary">Languages*</label>
            <select
              v-if="!otherLang"
              name=""
              id=""
              class="form-control"
              multiple
              v-model="interpreterUser.languages"
            >
              <option value="English">English</option>
              <option value="Spanish">Spanish</option>
              <option value="Portuguese">portuguese</option>
              <option value="French">French</option>
              <option value="Other">Other</option>
            </select>
            <input
              v-else
              placeholder="Other language"
              v-model="templang"
              class="form-control"
              id=""
            />
          </div>
          <div class="col-md-6 col-12">
            <label for="" class="text-primary">License State*</label>
            <select
              name=""
              id=""
              v-model="interpreterUser.location"
              class="form-control"
              multiple
            >
              <option value="Alabama">Alabama</option>
              <option value="Alaska">Alaska</option>
              <option value="Arizona">Arizona</option>
              <option value="Arkansas">Arkansas</option>
              <option value="California">California</option>
              <option value="Colorado">Colorado</option>
              <option value="Connecticut">Connecticut</option>
              <option value="Delaware">Delaware</option>
              <option value="District of Columbia">District of Columbia</option>
              <option value="Florida">Florida</option>
              <option value="Georgia">Georgia</option>
              <option value="Hawaii">Hawaii</option>
              <option value="Idaho">Idaho</option>
              <option value="Illinois">Illinois</option>
              <option value="Indiana">Indiana</option>
              <option value="Iowa">Iowa</option>
              <option value="Kansas">Kansas</option>
              <option value="Kentucky">Kentucky</option>
              <option value="Louisiana">Louisiana</option>
              <option value="Maine">Maine</option>
              <option value="Maryland">Maryland</option>
              <option value="Massachusetts">Massachusetts</option>
              <option value="Michigan">Michigan</option>
              <option value="Minnesota">Minnesota</option>
              <option value="Mississippi">Mississippi</option>
              <option value="Missouri">Missouri</option>
              <option value="Montana">Montana</option>
              <option value="Nebraska">Nebraska</option>
              <option value="Nevada">Nevada</option>
              <option value="New Hampshire">New Hampshire</option>
              <option value="New Jersey">New Jersey</option>
              <option value="New Mexico">New Mexico</option>
              <option value="New York">New York</option>
              <option value="North Carolina">North Carolina</option>
              <option value="North Dakota">North Dakota</option>
              <option value="Ohio">Ohio</option>
              <option value="Oklahoma">Oklahoma</option>
              <option value="Oregon">Oregon</option>
              <option value="Pennsylvania">Pennsylvania</option>
              <option value="Rhode Island">Rhode Island</option>
              <option value="South Carolina">South Carolina</option>
              <option value="South Dakota">South Dakota</option>
              <option value="Tennessee">Tennessee</option>
              <option value="Texas">Texas</option>
              <option value="Utah">Utah</option>
              <option value="Vermont">Vermont</option>
              <option value="Virginia">Virginia</option>
              <option value="Washington">Washington</option>
              <option value="West Virginia">West Virginia</option>
              <option value="Wisconsin">Wisconsin</option>
              <option value="Wyoming">Wyoming</option>
              <option value="American Samoa">American Samoa</option>
              <option value="Guam">Guam</option>
              <option value="Northern Mariana Islands">
                Northern Mariana Islands
              </option>
              <option value="Puerto Rico">Puerto Rico</option>
              <option value="Virgin Islands">Virgin Islands</option>
              <option value="Alberta">Alberta</option>
              <option value="British Columbia">British Columbia</option>
              <option value="Manitoba">Manitoba</option>
              <option value="New Brunswick">New Brunswick</option>
              <option value="Newfoundland and Labrador">
                Newfoundland and Labrador
              </option>
              <option value="Nova Scotia">Nova Scotia</option>
              <option value="Northwest Territories">
                Northwest Territories
              </option>
              <option value="Nunavut">Nunavut</option>
              <option value="Ontario">Ontario</option>
              <option value="Prince Edward Island">Prince Edward Island</option>
              <option value="Quebec">Quebec</option>
              <option value="Saskatchewan">Saskatchewan</option>
              <option value="Yukon">Yukon</option>
              <option value="Other">Other</option>
            </select>
          </div>
          <div class="col-md-6 col-12 mt-3">
            <label for="" class="text-primary">Degree/Certifications*</label>
            <select
              v-if="interpreterUser.certifications != 'Other'"
              name=""
              id=""
              class="form-control"
              v-model="interpreterUser.certifications"
            >
              <option value="MD">MD</option>
              <option value="DO">DO</option>
              <option value="Phd">Phd</option>
              <option value="PharmD">PharmD</option>
              <option value="LICSW">LICSW</option>
              <option value="LMFT">LMFT</option>
              <option value="Life-coach">Life-coach</option>
              <option value="Other">Other</option>
            </select>
            <input
              v-else
              type="text"
              name=""
              placeholder="Harvard"
              v-model="tempcert"
              class="form-control"
              id=""
            />
          </div>
          <div class="col-md-6 col-12 mt-3">
            <label for="" class="text-primary">Specialty*</label>
            <select
              v-if="interpreterUser.specialty != 'Other'"
              name=""
              id=""
              class="form-control"
              v-model="interpreterUser.specialty"
            >
              <option value="Primary Care Physician">
                Primary Care Physician
              </option>
              <option value="Psychiatrist">Psychiatrist</option>
              <option value="General">General</option>
              <option value="Obgyn">Obgyn</option>
              <option value="Psychologist">Psychologist</option>
              <option value="Social Worker">Social Worker</option>
              <option value="Nutritionist">Nutritionist</option>
              <option value="Physical Therapist">Physical Therapist</option>
              <option value="Other">Other</option>
            </select>
            <input
              v-else
              type="text"
              placeholder="Other Specialty"
              v-model="tempspecialty"
              class="form-control"
              id=""
            />
          </div>
          <div class="col-md-6 col-12 mt-3">
            <label for="" class="text-primary">Board Certified*</label>
            <select
              name=""
              id=""
              class="form-control"
              v-model="interpreterUser.certified"
            >
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </div>
          <div class="col-md-6 col-12 mt-3">
            <label for="" class="text-primary">Educational Institution</label>
            <input
              type="text"
              name=""
              placeholder="Harvard"
              v-model="interpreterUser.institute"
              class="form-control"
              id=""
            />
          </div>
          <div class="col-md-12 col-12 mt-3">
            <label for="" class="text-primary"
              >Do You have Liability/Indemnity Insurance?</label
            >
            <select
              name=""
              id=""
              class="form-control"
              v-model="interpreterUser.insurance"
            >
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
            <input
              v-if="interpreterUser.insurance == 'Yes'"
              type="file"
              @change="onInsuranceFilePicked"
            />
          </div>

          <!-- <div class="row"> -->
          <div class="col-md-5 col-12 mt-3">
            <label for="" class="text-primary">Business Name</label>
            <input
              type="text"
              placeholder="Oz treatments"
              v-model="interpreterUser.business_name"
              class="form-control"
              id=""
            />
          </div>
          <div class="col-md-3 p-md-0 col-12 mt-3">
            <label for="" class="text-primary">Opening</label>
            <input
              type="time"
              name=""
              v-model="interpreterUser.open_time"
              class="form-control"
              id=""
            />
          </div>
          <div class="col-md-3 p-md-0 ml-1 col-12 mt-3">
            <label for="" class="text-primary">Closing</label>
            <input
              type="time"
              name=""
              v-model="interpreterUser.close_time"
              class="form-control"
              id=""
            />
          </div>
        </div>
        <div class="col-md-12 col-12 mt-3">
          <label for="" class="text-primary">Business Address</label>
          <textarea
            class="form-control"
            rows="2"
            v-model="interpreterUser.address"
            placeholder="Your business location"
          ></textarea>
        </div>
        <div class="col-md-12 col-12 mt-3">
          <label for="" class="text-primary">Biography</label>
          <textarea
            class="form-control"
            rows="2"
            v-model="interpreterUser.about"
            placeholder="Write something about yourself (your clients will see this)"
          ></textarea>
        </div>
        <div class="col-md-12 col-12 mt-3">
          <button
            type="submit"
            class="btn btn-primary btn-block"
            @click="navigate()"
          >
            Create
          </button>
        </div>
        <!-- </div>  -->
      </b-container>
      <!-- <b-container fluid class="mt-4"> -->
      <!-- <md-button class="ml-2 md-dense md-raised md-primary pull-right">Create</md-button> -->
      <!-- <md-button class="md-dense md-raised md-primary pull-right" @click="hide('new-interpreter')">Cancel</md-button> -->
      <!-- </b-container> -->
    </b-modal>
  </div>
</template>
<script>
const toLower = (text) => {
  return text.toString().toLowerCase();
};

const searchByName = (items, term) => {
  if (term) {
    return items.filter((item) =>
      toLower(item.first_name).includes(toLower(term))
    );
  }

  return items;
};

// import { SimpleTable, OrderedTable } from "@/components";
import { mapGetters } from "vuex";
export default {
  name: "ServieProviders",
  data: () => ({
    interpreterUser: {
      first_name: null,
      last_name: null,
      middle_name: null,
      email: null,
      npi_number: null,
      certificate_no: null,
      password: null,
      confirm_password: null,
      business_name: null,
      gender: "Male",
      file: null,
      contact: null,
      languages: [],
      location: [],
      certifications: null,
      specialty: null,
      institute: null,
      open_time: null,
      close_time: null,
      insurancefile: "",
      address: null,
      insurance: null,
      certified: "No",
      about: null,
      type: "provider",
      status: "active",
    },
    search: null,
    edit: false,
    selected_user: "",
    searched: [],
    showDialog: false,
    templang: "",
    tempcert: "",
    tempspecialty: "",
  }),
  computed: {
    ...mapGetters(["service_providers", "allUsers"]),
    otherLang() {
      return this.interpreterUser.languages.find((item) => item == "Other");
    },

    getMessagedUsers() {
      if (this.selected_user.message_connections != null) {
        //   this.allUsers.map()
        return Object.keys(this.selected_user.message_connections).map(
          (key) => {
            let use = this.allUsers.find(
              (item) =>
                item.id == this.selected_user.message_connections[key].id
            );
            return {
              ...use,
              new_messages: this.selected_user.message_connections[key]
                .new_messages,
              last_time: this.selected_user.message_connections[key].last_time,
              last_date: this.selected_user.message_connections[key].last_date,
            };
          }
        );
      } else {
        return [];
      }
    },
  },
  watch: {
    service_providers() {
      this.searched = this.service_providers;
    },
  },
  methods: {
    onInsuranceFilePicked(event) {
      this.interpreterUser.insurancefile = event.target.files[0];
    },
    onFilePicked(event) {
      this.interpreterUser.file = event.target.files[0];
    },
    navigate() {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      let interpreter = this.interpreterUser;
      if (this.templang != "") {
        this.interpreterUser.languages.push(this.templang);
      }
      if (this.tempcert != "") {
        this.interpreterUser.certifications = this.tempcert;
      }
      if (this.tempspecialty != "") {
        this.interpreterUser.specialty = this.tempspecialty;
      }
      if (
        interpreter.first_name == null ||
        interpreter.last_name == null ||
        interpreter.email == null ||
        interpreter.gender == null ||
        interpreter.certifications == null ||
        interpreter.certified == null ||
        interpreter.file == null
      ) {
        this.$store.commit("setNotifications", {
          message: "Fill All Fields Required!",
          type: "error",
        });
      } else if (!re.test(interpreter.email.toLowerCase())) {
        this.$store.commit("setNotifications", {
          message: "Invalid Email!",
          type: "error",
        });
      } else if (interpreter.password == null) {
        this.$store.commit("setNotifications", {
          message: "Please Enter Password!",
          type: "error",
        });
      } else if (interpreter.confirm_password == null) {
        this.$store.commit("setNotifications", {
          message: "Please Confirm Your Password!!",
          type: "error",
        });
      } else if (interpreter.password != interpreter.confirm_password) {
        this.$store.commit("setNotifications", {
          message: "Password Mismatch!",
          type: "error",
        });
      } else {
        this.$store.dispatch("createUser", interpreter);

        this.interpreterUser = {
          first_name: null,
          last_name: null,
          middle_name: null,
          email: null,
          npi_number: null,
          certificate_no: null,
          password: null,
          confirm_password: null,
          business_name: null,
          gender: "Male",
          contact: null,
          file: null,
          languages: [],
          location: [],
          certifications: null,
          specialty: null,
          institute: null,
          open_time: null,
          close_time: null,
          insurancefile: "",
          address: null,
          insurance: null,
          certified: null,
          about: null,
          type: "provider",
          status: "active",
        };
        this.hide("new-interpreter");
      }
    },
    //
    lc_DelUser(item) {
      this.$bvModal.hide("modal-1");
      // console.log(item)
      this.$store.dispatch("DeleteUser", item);
    },
    lc_blockUser(item) {
      this.$bvModal.hide("modal-1");
      // console.log(item)
      if (item.status == "active") {
        this.$store.dispatch("blockUser", item.id);
      } else {
        this.$store.dispatch("unblockUser", item.id);
      }
      //   this.$store.dispatch("blockUser", item);
    },
    setUser(item) {
      this.selected_user = item;
      this.$bvModal.show("modal-1");
    },
    hide(id) {
      this.$bvModal.hide(id);
    },
    searchOnTable() {
      this.searched = searchByName(this.service_providers, this.search);
    },
  },
  created() {
    this.searched = this.service_providers;
  },
};
</script>

<style scoped>
.shadow {
  box-shadow: 0 0.2rem 0.2rem rgba(0, 0, 0, 0.15) !important;
}
</style>
